import {Component, OnInit, OnChanges} from '@angular/core';
import {Router} from '@angular/router';

import 'rxjs/add/operator/map';
import {AuthControllerService} from "../../../services/auth-controller/auth-controller.service";

@Component({
    selector: 'login-page',
    templateUrl: `./dashboard.component.html`
})
export class DashboardPage implements OnInit, OnChanges {
    currentUserIsAdmin: boolean;
    currentUserIsAnalyst: boolean;
	currentUserIsInstitutionManager: boolean;

    constructor(private authService: AuthControllerService) {
    }

    ngOnInit(): void {
        this.bindRoles = this.bindRoles.bind(this);
        this.authService.subscribeForTokenChange(this.bindRoles);
		this.bindRoles();
    }
    
    ngOnChanges(){
        this.ngOnInit();
    }
	
	ngOnDestroy(): void {
		this.authService.unsubscribe(this.bindRoles);
	}

    private bindRoles() {
        this.currentUserIsAdmin = this.authService.resolveRole('sysadmin');
        this.currentUserIsAnalyst = this.authService.resolveRole('stat_analyst');
		this.currentUserIsInstitutionManager = this.authService.resolveRole('superinspector');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/dashboard/dashboard.component.ts